import React from 'react';
import App from '../../../sampleApp/src/CometChatBuilderApp';
import './style.css';

/**
 * Props for the ChatWrapper component.
 */
interface ChatWrapperProps {
  /** Indicates if the chat is being viewed on a mobile device. */
  isMobile: boolean;
  /** Specifies the height of the chat wrapper. */
  chatWrapperHeight: string;
  /** Determines if the chat is displayed in full-screen mode. */
  isFullScreen?: boolean;
}

/**
 * ChatWrapper component responsible for displaying the chat interface with a loading spinner.
 *
 * @param {ChatWrapperProps} props - Component props.
 * @returns {JSX.Element} The rendered ChatWrapper component.
 */
const ChatWrapper = ({ isMobile, chatWrapperHeight, isFullScreen }: ChatWrapperProps) => {
  return (
    <div
      id="chatWrapper"
      className={`chatWrapper ${!isFullScreen ? 'chatWrapperCustomise' : ''}`}
      style={{ height: chatWrapperHeight }}
    >
      <div className={isMobile ? 'mobileChat' : ''}>
        <App />
      </div>
    </div>
  );
};

export default React.memo(ChatWrapper);
